import { Component } from '@angular/core';

import type { ICellRendererAngularComp } from 'ag-grid-angular';
import type { ICellRendererParams } from 'ag-grid-community';
import { BehaviorSubject, Subscription } from 'rxjs';

import { IPresentationProfile } from './EditWebcast.Contract';

export interface IAvailabilityIconCellRendererParams {
	selectedProfile$: BehaviorSubject<string>;
}

interface IAvailabilityIconCellRendererMergedParams extends ICellRendererParams, IAvailabilityIconCellRendererParams { }

@Component({
	selector: 'availability-icon-cell-renderer',
	template: `
		<span *ngIf="iconClass" [ngClass]="iconClass"></span>
		<span *ngIf="!profile.videoSource.deviceIsActive" class="glyphicons warning_sign" [tooltip]="'Admin_PresentationProfile_SourceDeviceInactive' | translate"></span>
	`,
	standalone: false
})
export class AvailabilityIconCellRendererComponent implements ICellRendererAngularComp {
	public profile: IPresentationProfile;
	public iconClass: string;
	private subscription: Subscription;

	public agInit(params: IAvailabilityIconCellRendererMergedParams): void {
		this.updateCell(params);
	}

	public refresh(params: IAvailabilityIconCellRendererMergedParams): boolean {
		this.updateCell(params);

		return true;
	}

	public destroy() {
		this.subscription?.unsubscribe();
	}

	private updateCell(params: IAvailabilityIconCellRendererMergedParams): void {
		this.profile = params.data;
		this.subscription = params.selectedProfile$.subscribe(selectedProfile => {
			this.setIconClass(selectedProfile);
		});

	}

	private setIconClass(selectedProfile: string): void {
		if (selectedProfile !== this.profile.id) {
			this.iconClass = this.profile.available ? 'glyphicons circle_ok icon-success' : 'glyphicons circle_minus icon-disabled';
		} else {
			this.iconClass = this.profile.available ? 'glyphicons circle_minus icon-disabled' : 'glyphicons circle_exclamation_mark icon-danger';
		}
	}
}
